import { Text, VStack } from '@chakra-ui/react';
import { Num } from '@ui/components/Num';
import { Fraction } from 'bi-fraction';

export const ProfileInfo = () => {
  // todo cover.lv mock data
  const tokenHoldingsTotal = new Fraction('12346324');
  const agentsCreatedTotal = new Fraction('7688655');
  return (
    <VStack textAlign="center">
      <Text textStyle="overline" color="secondary.persianBlue">
        Token holdings
      </Text>
      <Num value={tokenHoldingsTotal} textStyle="body2Bold" />
      <Text textStyle="overline" color="secondary.persianBlue" mt="8px">
        Agents created
      </Text>
      <Num value={agentsCreatedTotal} textStyle="body2Bold" />
    </VStack>
  );
};
